/** @typedef {import('@sentry/types').Integration} SentryIntegration */

import { getUserFromCookie } from "../cookies/library";

/**
 * sentrySetUserIDIntegration
 *
 * This integration attaches a user ID to an error event so we can track user-specific errors in Sentry.
 * The ID comes from either the authenticated (cbc_plus) or unauthenticated (cbc_visitor) user cookie.
 * If an ID is not found, the user is set to null which clears the previous user.
 *
 * @return {SentryIntegration}
 */
const sentrySetUserIDIntegration = () => {
    return {
        name: "SentrySetUserIDIntegration",
        processEvent(event) {
            try {
                const user = getUserFromCookie();
                const userID = user?.id;

                if (userID && userID.length > 0) {
                    event.user = {
                        id: userID,
                    };
                } else {
                    event.user = null;
                }
            } catch (err) {
                event.user = null;
            }

            return event;
        },
    };
};

export default sentrySetUserIDIntegration;
